import { render, staticRenderFns } from "./DigitalMarketingLandingPage.vue?vue&type=template&id=3fa5dda1&scoped=true&"
import script from "./DigitalMarketingLandingPage.vue?vue&type=script&lang=js&"
export * from "./DigitalMarketingLandingPage.vue?vue&type=script&lang=js&"
import style0 from "./DigitalMarketingLandingPage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DigitalMarketingLandingPage.vue?vue&type=style&index=1&id=3fa5dda1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa5dda1",
  null
  
)

export default component.exports